import { React, useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  PublicJobsList,
  PublicJobOverview,
} from "..";

function PublicJobDisplay() {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState({});
  const [isLoaded, setLoaded] = useState(false);

  const getJobs = () => {
    axios.get("/company/getJobs").then((res) => {
      const data = res.data;
      if (data.success) {
        setJobs(data.jobs);
        setSelectedJob(data.jobs[0]);
      }
    });
  };

  const handleSelectedJob = (job) => {
    setSelectedJob(job);
  };

  // To only update the jobs, not unselecting job and not going back to page 1
  useEffect(() => {
    if(!isLoaded) {
        getJobs();
        setLoaded(true);
    }
  });

  return (
    <div className="bg-brand-tertiary">
        <div className="w-[30%] h-screen inline-block p-2">
            <PublicJobsList
                jobs={jobs}
                selectedJob={selectedJob}
                setSelectedJob={setSelectedJob}
            />
        </div>
        <div className="w-[70%] h-screen inline-block align-top p-2">
            <PublicJobOverview
                job ={selectedJob}
            />
        </div>
    </div>
  );
}
export default PublicJobDisplay;
